import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=4fa7ff36&scoped=true&"
import script from "./BillsList.vue?vue&type=script&lang=js&"
export * from "./BillsList.vue?vue&type=script&lang=js&"
import style0 from "./BillsList.vue?vue&type=style&index=0&id=4fa7ff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7ff36",
  null
  
)

export default component.exports